{
  "schema_version": "1.0",
  "run_id": "run_20260712_130000_ist",
  "edition_key": "2026-07-12-1300-Asia-Kolkata",
  "created_at": "2026-07-12T07:34:00Z",
  "gate_state": "GATE_PASSED",
  "model_id": "eleven_multilingual_v2",
  "segments": [
    {
      "order": 1,
      "segment_id": "S01",
      "line_id": "L001",
      "speaker": "ANCHOR_A",
      "line_type": "fact",
      "text": "केंद्रीय मंत्रिमंडल ने बारह हजार करोड़ रुपये की हरित हाइड्रोजन मिशन को मंजूरी दी।",
      "claim_ids": ["C001"],
      "voice_config_key": "ELEVENLABS_VOICE_A",
      "output_path": "runs/run_20260712_130000_ist/segments/S01.mp3",
      "audio_sha256": null
    },
    {
      "order": 2,
      "segment_id": "S02",
      "line_id": "L002",
      "speaker": "ANCHOR_B",
      "line_type": "transition",
      "text": "अब अगली खबर।",
      "claim_ids": [],
      "voice_config_key": "ELEVENLABS_VOICE_B",
      "output_path": "runs/run_20260712_130000_ist/segments/S02.mp3",
      "audio_sha256": null
    },
    {
      "order": 3,
      "segment_id": "S03",
      "line_id": "L003",
      "speaker": "ANCHOR_B",
      "line_type": "fact",
      "text": "भारतीय रिज़र्व बैंक ने रेपो दर पाँच दशमलव पाँच प्रतिशत पर बरकरार रखी।",
      "claim_ids": ["C002"],
      "voice_config_key": "ELEVENLABS_VOICE_B",
      "output_path": "runs/run_20260712_130000_ist/segments/S03.mp3",
      "audio_sha256": null
    },
    {
      "order": 4,
      "segment_id": "S04",
      "line_id": "L004",
      "speaker": "ANCHOR_A",
      "line_type": "transition",
      "text": "आगे बढ़ते हैं।",
      "claim_ids": [],
      "voice_config_key": "ELEVENLABS_VOICE_A",
      "output_path": "runs/run_20260712_130000_ist/segments/S04.mp3",
      "audio_sha256": null
    },
    {
      "order": 5,
      "segment_id": "S05",
      "line_id": "L005",
      "speaker": "ANCHOR_A",
      "line_type": "fact",
      "text": "दिल्ली में दक्षिण-पश्चिम मानसून अपनी सामान्य तिथि से दो दिन पहले पहुँच गया।",
      "claim_ids": ["C003"],
      "voice_config_key": "ELEVENLABS_VOICE_A",
      "output_path": "runs/run_20260712_130000_ist/segments/S05.mp3",
      "audio_sha256": null
    },
    {
      "order": 6,
      "segment_id": "S06",
      "line_id": "L006",
      "speaker": "ANCHOR_B",
      "line_type": "transition",
      "text": "ये थीं आज की सत्यापित खबरें। यह बुलेटिन एआई द्वारा तैयार किया गया है और हर तथ्य स्रोत-जाँचा है।",
      "claim_ids": [],
      "voice_config_key": "ELEVENLABS_VOICE_B",
      "output_path": "runs/run_20260712_130000_ist/segments/S06.mp3",
      "audio_sha256": null
    }
  ],
  "final_audio_path": "runs/run_20260712_130000_ist/episode.mp3"
}
